import { useTranslation } from 'react-i18next'
import { FieldInput, FieldDropdown } from '@/components/form'
import useBasic from '@/hooks/use-basic'
import { getFormattedStates } from '@/utils/address'

const StateDropdown = ({
  country: initialCountry = 'ca',
  required = false,
  isSearchable = true,
  ...rest
}) => {
  const { t } = useTranslation()
  const { countries } = useBasic(['countries'])
  const country = initialCountry.toLowerCase()

  const getField = () => {
    if (country === 'ca')
      return (
        <FieldDropdown
          id="state"
          options={getFormattedStates(countries, 'ca')}
          placeholder={t('r.profile.edit.province.label', 'Province')}
          required={required}
          isSearchable={isSearchable}
          {...rest}
        />
      )
    if (country === 'us')
      return (
        <FieldDropdown
          id="state"
          options={getFormattedStates(countries, 'us')}
          placeholder={t('r.profile.edit.state.label', 'State')}
          required={required}
          isSearchable={isSearchable}
          {...rest}
        />
      )
    return (
      <FieldInput
        id="state"
        placeholder={t('r.profile.edit.state_province.label', 'State / Province')}
        required={required}
        {...rest}
      />
    )
  }

  return <>{getField()}</>
}

export default StateDropdown
